import { useEffect, useState } from 'react';
import { isCatchUpCapable } from 'utils/fnData';

export const useAssetReplayCapable = (data: any /* , channel?: Channel */) => {
    const [isReplayCapable, setIsReplayCapable] = useState(false);

    // info from data object
    const startTime = data?.listings?.[0]?.start;
    const replayUntil = data?.listings?.[0]?.replayUntil || data?.listings?.[0]?.replay_until;
    const channelHasReplay = !!replayUntil;
    const now = Math.floor(Date.now() / 1000);

    useEffect(() => {
        if (!data || !data.listings || !data.listings[0] || !('start' in data.listings[0])) {
            setIsReplayCapable(false);
            return;
        }

        setIsReplayCapable(
            startTime != null &&
                channelHasReplay != null &&
                startTime < now &&
                isCatchUpCapable(startTime, channelHasReplay, replayUntil /* getReplayWindowTimeFrame() */) //
        );
    }, [data]);

    return {
        isReplayCapable,
    };
};
